var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0749 23.6554C27.0749 31.1968 21.0139 37.3103 13.5377 37.3103C6.06146 37.3103 0 31.1955 0 23.6554C0 16.1153 6.061 10 13.5377 10C21.0143 10 27.0749 16.114 27.0749 23.6554Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9256 23.6554C41.9256 30.7541 38.8951 36.5109 35.1568 36.5109C31.4184 36.5109 28.3879 30.7541 28.3879 23.6554C28.3879 16.5568 31.418 10.7999 35.1563 10.7999C38.8947 10.7999 41.9252 16.555 41.9252 23.6554",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 23.6554C47.9999 30.0141 46.9342 35.1719 45.6193 35.1719C44.3043 35.1719 43.2391 30.0154 43.2391 23.6554C43.2391 17.2954 44.3048 12.1389 45.6193 12.1389C46.9338 12.1389 47.9999 17.2949 47.9999 23.6554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.cfd7d9055a92d9200e8e831d6533c311.svg";
export { ForwardRef as ReactComponent };